import React from "react";
import { AlertTriangle } from "lucide-react";

export const AiSignal = ({ signal }) => {
    if (!signal) return null;
    return (
        <section className="panel" data-testid="ai-signal">
            <div className="px-6 sm:px-8 py-5 border-b hairline flex items-start justify-between gap-6">
                <div>
                    <p className="mono-label">Step 02 · Responsible AI support</p>
                    <h2
                        className="font-serif mt-1"
                        style={{ fontSize: 28, letterSpacing: "-0.01em" }}
                    >
                        Synthetic responsible-AI support signal
                    </h2>
                </div>
                <div
                    className="hidden sm:inline-flex items-center gap-2 border border-[var(--rule)] px-3 py-1.5"
                    style={{ background: "#FFF8E6" }}
                >
                    <AlertTriangle size={14} strokeWidth={1.5} />
                    <span className="mono-label" style={{ color: "var(--ink)" }}>
                        Not a diagnosis · Not a prescription
                    </span>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3">
                <div className="px-6 sm:px-8 py-6 lg:border-r hairline">
                    <p className="mono-label">Framing</p>
                    <p
                        className="font-serif mt-3"
                        style={{ fontSize: 16.5, lineHeight: 1.55 }}
                    >
                        {signal.framing}
                    </p>
                </div>
                <div className="px-6 sm:px-8 py-6 lg:border-r hairline">
                    <p className="mono-label">Review-worthy signal</p>
                    <p
                        className="mt-3"
                        style={{
                            fontSize: 14.5,
                            color: "var(--ink-soft)",
                            lineHeight: 1.6,
                        }}
                    >
                        {signal.review_worthy_signal}
                    </p>
                </div>
                <div className="px-6 sm:px-8 py-6">
                    <p className="mono-label">Rationale & boundary</p>
                    <p
                        className="mt-3"
                        style={{
                            fontSize: 14.5,
                            color: "var(--ink-soft)",
                            lineHeight: 1.6,
                        }}
                    >
                        {signal.rationale}
                    </p>
                    <p
                        className="mt-3 font-serif"
                        style={{ fontSize: 15, color: "var(--forest)" }}
                    >
                        {signal.boundary}
                    </p>
                </div>
            </div>

            <div className="px-6 sm:px-8 py-4 panel-alt border-t hairline">
                <p className="mono-label mb-2">Evidence references only</p>
                <div className="flex flex-wrap gap-2">
                    {(signal.evidence_refs || []).map((r) => (
                        <span
                            key={r}
                            className="mono-data border border-[var(--rule)] bg-white px-2 py-1"
                            style={{ fontSize: 11.5 }}
                        >
                            {r}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AiSignal;
